/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
import { OpaqueToken  } from "@angular/core";
import { IExpandablePanel } from './IExpandablePanel.interface';

export interface IExpandablePanelCollection {
    get(panelId: string): IExpandablePanel;
    add(panel: IExpandablePanel): void;
    remove(panel: IExpandablePanel): void;
}

export const IEXPANDABLEPANELCOLLECTIONSERVICE_TOKEN: OpaqueToken = new OpaqueToken('IExpandablePanelCollectionService');